import { Spinner } from '@heroui/react'

interface LoaderProps {
	isLoading: boolean
	alternate?: boolean
	text: string
}

export default function Loader({ isLoading, text }: LoaderProps) {
	if (!isLoading) {
		return null
	}

	return (
		<div className="flex items-center justify-center">
			<section className="p-2.5 px-4 flex flex-row items-center gap-2">
				<Spinner
					size={'sm'}
					className={'p-2'}
					classNames={{
						circle1: 'border-l-colourSky60',
						circle2: 'border-l-colourSky60',
					}}
				/>

				<div className="p-2 text-xl text-colourSky80">{text}</div>
			</section>
		</div>
	)
}
